import { render, staticRenderFns } from "./index.vue?vue&type=template&id=139608a7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=139608a7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139608a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('139608a7')) {
      api.createRecord('139608a7', component.options)
    } else {
      api.reload('139608a7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=139608a7&scoped=true", function () {
      api.rerender('139608a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/bargain/bargainGoods/index.vue"
export default component.exports